/**
 * KitPairChip — small linked-pair badge shown next to a Serial No.
 * whenever the row was intaken as part of a Kit (R + L pair sharing a
 * `kit_id` — see 2026-02-13 refactor).
 *
 * Reads (all optional — the chip degrades gracefully):
 *   • item.kit_id    — UUID stamped on BOTH aids of the pair.
 *   • item.kit_side  — 'left' | 'right'.
 *   • partnerSerial  — sister aid's serial_no (resolved by caller so
 *                      the tooltip reads "pairs with SN-XYZ").
 *
 * If `kit_id` is falsy the component renders `null` — safe to drop
 * into any row unconditionally.
 */
import React from 'react';
import { Link2 } from 'lucide-react';

export default function KitPairChip({ item, partnerSerial, testId }) {
  if (!item?.kit_id) return null;
  const side =
    item.kit_side === 'left' ? 'L'
    : item.kit_side === 'right' ? 'R'
    : '?';
  const tip = partnerSerial
    ? `Kit pair · this is the ${item.kit_side || 'unknown'} aid · sister serial: ${partnerSerial}`
    : `Kit pair · this is the ${item.kit_side || 'unknown'} aid · sister serial not in current view`;
  return (
    <span
      title={tip}
      data-testid={testId || `kit-chip-${item.serial_id}`}
      className="ml-1.5 inline-flex items-center gap-0.5 align-middle text-[9px] font-bold uppercase tracking-wider bg-indigo-50 text-indigo-800 border border-indigo-300 rounded px-1 py-[1.5px] cursor-help"
    >
      <Link2 size={9} strokeWidth={2.5} />
      Kit · {side}
    </span>
  );
}
